import { FC } from 'react'

import { Button, Flex, Text } from '@chakra-ui/react'
import { CubeIcon } from '@editor/assets/icons'
import { InspectionArea } from '@editor/interfaces/inspection'
import { RootState } from '@editor/store/app'
import { useSelector } from 'react-redux'
import { Link as RouterLink } from 'react-router'

const NoData: FC<{ message: string; inspectionArea: InspectionArea; hidden?: boolean }> = ({
  message,
  inspectionArea,
  hidden,
}) => {
  // Store
  const project = useSelector((state: RootState) => state.page.project)

  return (
    <Flex className={['no-data', hidden ? 'hidden' : ''].join(' ')}>
      <Text>{message}</Text>
      <Button mt={6} variant="outline" bg="white" fontSize="md" size="lg" asChild>
        <RouterLink to={`/projects/${project?.project_id}/editor?area=${inspectionArea.inspection_area_id}`}>
          <CubeIcon />
          3D画面でエリアを開く
        </RouterLink>
      </Button>
    </Flex>
  )
}

export default NoData
